import React from "react";
import { useContext } from "react";
import { Mentionable } from "../../../../../../../../../common/sesh_types";
import { RouterInferenceHelpers } from "../../../../../../../../../src/api/trpc/rootRouter";

export const PublicCalendarContext =
	React.createContext<PublicCalendarContextType>({
		is_public: false,
	});

type PublicCalendarContextType =
	| {
			is_public: true;
			authors: Mentionable[];
			channels: RouterInferenceHelpers["calendar"]["view"]["output"]["channels"];
	  }
	| { is_public: false };

export function usePublicCalendarContext() {
	return (
		useContext(PublicCalendarContext) ?? {
			is_public: false as const,
		}
	);
}
